import getConfig from 'next/config';

export const envVariables = {
  NEXT_PUBLIC_RECAPTCHA_API_KEY:
    getConfig()?.publicRuntimeConfig.NEXT_PUBLIC_RECAPTCHA_API_KEY,
  NEXT_PUBLIC_GOOGLE_MAPS_API_KEY:
    getConfig()?.publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  NEXT_PUBLIC_RECAPTCHA_API_KEY_V3:
    getConfig()?.publicRuntimeConfig.NEXT_PUBLIC_RECAPTCHA_API_KEY_V3,
};
export const verticalMapId = '8bc3e5e8f1c4360e';

export const xApiKey = '80b45f1c-787d-43d6-b86f-9af8c51f6bb6';

export const BASE_URL = 'https://esim.bakcell.com/api/';
export const CITYNET_URL = 'https://citynet.az/api/city-web/api/';

export const WOLT_BASE_URL =
  'http://dev-dg-env.azerconnect.az/wolt-delivery-service/';

export const defaultHeaders = {
  // 'Content-Language': 'az',
  Referrer: 2,
  'Provider-Id': 2,
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, HEAD',
  'x-api-version': '1.0.0',
  'x-app-id': 'b6920d9083c8e76685bcc8db34b8c9bb',
};

// export const SERVER_URL = 'http://digitalsales-02.azerconnect.az:8602/api/';
// export const CLIENT_URL = 'http://digitalsales-02.azerconnect.az:8602/api/';
// export const MEDIA_URL = 'http://digitalsales-01.azerconnect.az:8601/';
// export const BKC_URL = 'http://digitalsales-02.azerconnect.az:8602/';
// export const SERVER_URL =
//   'http://digitalsales-01.azerconnect.az:8082/api/bkc-web/api';
// export const CLIENT_URL = 'https://www.bakcell.com/api/bkc-web/api/';
// export const CLIENT_MEDIA_URL =
//   process.env.NODE_ENV === 'development' ? 'https://www.bakcell.com' : '';
export const SERVER_MEDIA_URL = 'https://www.bakcell.com';
export const BKC_URL = 'https://www.bakcell.com/api/';
export const DEV_URL = 'https://dev-api.bakcell.com/api';
export const SERVER_URL = 'https://prod-api.bakcell.com/api';
export const CLIENT_URL = 'https://www.bakcell.com/api/bkc-web/api/';
export const CLIENT_MEDIA_URL =
  process.env.NODE_ENV === 'development' ? 'https://prod-api.bakcell.com/' : '';

export const CITYNET_FIBER_URL =
  'http://digitalsales-01.azerconnect.az:8081/api/city-web/api/partners/';
// export const CABINET_LOGIN_URL =
//   'http://digitalsales-02.azerconnect.az:8123/api/v1';
// export const CABINET_ACCOUNTS_URL =
//   'http://digitalsales-03.azerconnect.az:8500/v1';
// export const CABINET_TARIFFS_URL =
//   'http://digitalsales-03.azerconnect.az:8505/v1';
// export const CABINET_PACKAGES_URL =
//   'http://digitalsales-03.azerconnect.az:8507/v1';
